import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  makeStyles,
  MuiThemeProvider,
  createMuiTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteModelo,
  getModeloById,
  postModelo,
  updateModelo,
} from "../../../../api/modelo";
import { getMarcas } from "../../../../api/marca";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { Autocomplete } from "@material-ui/lab";
import { TarjetaModelo } from "../../../components/TarjetaModelo";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";

const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: 0,
    overflow: "hidden",
  },
  fancyLoader: {
    color: "#AF9A51 ",
    animation: `$spin 1s linear infinite`,
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));
function removeAccents(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export default function EditModeloPage({ close }) {
  const [modelo, setModelo] = useState({
    active: true,
    sku: "",
    nombre: "",
    marca: "",
    materialCaja: "",
    colorEsfera: "",
    diametro: "",
    // discountPercent stored as number (0-100)
    discountPercent: 0,
    urlImage: "",
  });
  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState({});
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  let modeloId = useParams().id;
  modeloId = !close ? modeloId : null;
  const classes = useStyles();
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const resMarcas = await getMarcas();

        if (resMarcas.status === 200) {
          setMarcas(resMarcas.data);
        } else {
          setLoading(false);
          alertError({ customMessage: "Could not get marcas." });
        }
        if (modeloId) {
          getModeloById(modeloId)
            .then((resModelo) => {
              if (resModelo.status === 200) {
                setModelo(resModelo.data);
                const marca = resMarcas.data.find(
                  (x) => x._id === resModelo.data.marca
                );
                setSelectedMarca(marca);
              }
            })
            .catch((error) => {
              setLoading(false);
              alertError({
                error,
                customMessage: "Could not get modelo details.",
              });
              history.push("/modelos");
            });
        }
      } catch (error) {
        setLoading(false);
        alertError({ error: error });
      }
    };

    fetchData();
    setLoading(false);
  }, [modeloId, history]);

  const handleChange = (field) => (event) => {
    setModelo({ ...modelo, [field]: event.target.value });
  };

  const handleNumberChange = (field) => (event) => {
    const raw = event.target.value;
    const num = raw === "" ? "" : Number(raw);
    setModelo({ ...modelo, [field]: num });
  };

  const handleSave = () => {
    if (!selectedMarca) {
      alertError({
        customMessage: "Es necesario rellenar la marca",
      });
      return;
    }
    modelo.marca = selectedMarca._id;

    // Validate discountPercent on client side (0..100)
    const dp = Number(modelo.discountPercent);
    if (isNaN(dp) || dp < 0 || dp > 100) {
      alertError({ customMessage: "Descuento % debe estar entre 0 y 100" });
      return;
    }
    modelo.discountPercent = dp;

    if (!modeloId) {
      postModelo(modelo)
        .then((res) => {
          alertSuccess({
            title: "Saved!",
            customMessage: "Modelo saved successfully.",
          });
          if (close) {
            close(res.data);
          } else {
            history.push("/modelos");
          }
        })
        .catch((error) => {
          alertError({
            error,
            customMessage: "Could not save modelo details.",
          });
        });
    } else {
      updateModelo(modeloId, modelo)
        .then((res) => {
          alertSuccess({
            title: "Saved!",
            customMessage: "Modelo saved successfully.",
          });
          if (close) {
            close(res.data);
          } else {
            history.push("/modelos");
          }
        })
        .catch((error) => {
          alertError({
            error,
            customMessage: "Could not save modelo details.",
          });
        });
    }
  };

  return (
    <>
      <Card>
        <CardHeader title="Edit Modelo" />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <CircularProgress className={classes.fancyLoader} />
          </div>
        ) : (
          <CardBody>
            <div className="row d-flex align-items-center">
              <div className="col-md-4">
                <Autocomplete
                  className="w-100 mr-5"
                  id="autocomplete-marca"
                  filterSelectedOptions
                  options={marcas}
                  getOptionLabel={(option) => option?.nombre}
                  value={selectedMarca}
                  onChange={(event, selected) => {
                    setSelectedMarca(selected);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label="Marca"
                    />
                  )}
                />
              </div>
              <div className="col-md-4">
                <TextField
                  label="idRef"
                  value={modelo.sku}
                  onChange={handleChange("sku")}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  required
                />
              </div>
              <div className="col-md-4">
                <TextField
                  label="Nombre"
                  value={modelo.nombre}
                  onChange={handleChange("nombre")}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  required
                />
              </div>
            </div>
            <div className="row d-flex align-items-center">
              <div className="col-md-4">
                <TextField
                  label="Color Esfera"
                  value={modelo.colorEsfera}
                  onChange={handleChange("colorEsfera")}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-4">
                <TextField
                  label="Material Caja"
                  value={modelo.materialCaja}
                  onChange={handleChange("materialCaja")}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-4">
                <TextField
                  label="Diametro"
                  value={modelo.diametro}
                  onChange={handleChange("diametro")}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-4">
                <TextField
                  label="Descuento %"
                  value={modelo.discountPercent}
                  onChange={handleNumberChange("discountPercent")}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  type="number"
                  inputProps={{ min: 0, max: 100, step: 0.01 }}
                  helperText="Valor entre 0 y 100"
                />
              </div>
            </div>
            <br />
            <br />
            <FormControlLabel
              control={
                <Checkbox
                  checked={modelo.active}
                  onChange={() =>
                    setModelo({ ...modelo, active: !modelo.active })
                  }
                />
              }
              label="Active"
            />
          </CardBody>
        )}
      </Card>
      <Button
        onClick={() => {
          if (close) {
            close(null);
          } else {
            history.push("/modelos");
          }
        }}
        variant="outlined"
        style={{ marginRight: "20px" }}
      >
        Back
      </Button>
      <Button
        onClick={handleSave}
        variant="outlined"
        color="primary"
        style={{ marginRight: "20px" }}
      >
        Save
      </Button>
      {modeloId && (
        <>
          <MuiThemeProvider theme={theme}>
            <Button
              onClick={() => setOpenConfirmDialog(true)}
              variant="outlined"
              color="secondary"
            >
              Delete
            </Button>
          </MuiThemeProvider>

          <ConfirmDialog
            title={"Are you sure you want to delete this watch?"}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteModelo(modeloId, modelo)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Delete successfully.",
                    });
                    history.push("/modelos");
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not save changes.",
                  });
                });
            }}
          />
        </>
      )}
    </>
  );
}
